<template>
  <h3 class="oido-value-list-item" :class="{ [typeClassName]: true }">
    <span class="label" v-text="label"></span>: <component :is="valueElement" :target="target"  :href="valueLink" class="value" v-text="preparedValue"></component>
  </h3>
</template>

<script>

export default {
  props: ["value", "label", "type"],
  computed: {
    typeClassName() {
      return "type-" + (typeof this.value)
    },
    preparedValue() {
      if (typeof this.value == 'boolean') {
        return this.value ? 'yes' : 'no'
      }
      if(this.type == 'url'){
        return (''+this.value).replaceAll('https://','').replaceAll('http://','')
      }

      return this.value
    },
    target(){
      return (this.type == 'url') ? '_blank': undefined
    },
    valueElement() {

      if (this.type) {
        if (
          this.type == 'email' ||
          this.type == 'url' ||
          this.type == 'phone'
        ) {
          return 'a'
        }
      }

      return 'span'
    },
    valueLink() {

      if (this.type) {
        if (this.value && this.type == 'email') {
          return 'mailto:' + this.value.trim()
        }
        if (this.type == 'phone') {
          return ('tel:' + this.value).replaceAll(' ', '').trim()
        }
        if (this.type == 'url') {          
          if(this.value && !this.value.includes('http://') && !this.value.includes('https://')){
            return ('https://' + this.value).trim()
          }
          return this.value
        }
      }

      return undefined
    }

  }


}
</script>


<style scoped>
.oido-value-list-item {
  margin: 0 0 0.5rem 0;
}

h3 {
  font-size: 0.8rem;
  color: var(--ion-color-dark);
  margin: 0.5rem 0;

}

h3 .label {
  font-weight: 599;
  display: inline-block;
}

h3 .label:first-letter {
  display: none;
  display: none;
  text-transform: uppercase;
}
</style>